import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['selected']

  toggle() {
    this.context.element.classList.toggle('is--selected', this.selectedTarget.checked);
  }
}
